export default {
  LEFT_MENU: {
    COLLAPSED: 'LAYOUT/DEFAULT/LEFT_MENU/COLLAPSED',
    EXPANDED: 'LAYOUT/DEFAULT/LEFT_MENU/EXPANDED',
  }
};
